import React from "react";

const FormCard = ({ children, className = "", ...rest }) => {
  return (
    <div
      className={`rounded-xl h-fit border border-[#D4D4D4] bg-white p-6 shadow-sm ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
};

export default FormCard;
